// Local translations
export const T = {
  en_GB: {
    addTemplate: "Add template",
    editTemplate: "Edit template",
    description:
      "A template is an allocation — ISINs and weights, nothing else. How it is enforced is set in the rules above.",
    name: "Name",
    namePlaceholder: "e.g., Balanced 60/40",
    riskScore: "Risk score",
    platforms: "Platforms",
    platformsHelp:
      "Platforms this template is offered under, like a model portfolio. Instruments are limited to products available on every selected platform. None selected = offered only to goals without a platform.",
    mode: "Mode",
    modeFixed: "Fixed weights",
    modeFixedHint: "One exact weight per instrument; any difference is a breach.",
    modeMinMax: "Min/max weights",
    modeMinMaxHint: "A minimum, default and maximum per instrument; outside the band is a breach.",
    instruments: "Instruments",
    save: "Save",
    cancel: "Cancel",
    nameRequired: "Name is required",
    needLines: "Add at least one instrument",
    fixedTotal: "Weights must total 100 %",
    defaultTotal: "Default weights must total 100 %",
    rangeOrder: "Each instrument needs minimum ≤ default ≤ maximum",
    rangeUnreachable: "The bands must permit an allocation totalling 100 %",
    pctRange: "Every figure must be between 0 and 100",
    uncovered: "Remove the instruments that are not available on every selected platform",
    failedToSave: "Failed to save the template",
  },
  nb_NO: {
    addTemplate: "Legg til mal",
    editTemplate: "Rediger mal",
    description:
      "En mal er en allokering — ISIN-er og vekter, ikke noe annet. Hvordan den håndheves settes i reglene over.",
    name: "Navn",
    namePlaceholder: "f.eks. Balansert 60/40",
    riskScore: "Risikoscore",
    platforms: "Plattformer",
    platformsHelp:
      "Plattformer denne malen tilbys under, som en modellportefølje. Instrumenter begrenses til produkter som er tilgjengelige på alle valgte plattformer. Ingen valgt = tilbys bare mål uten plattform.",
    mode: "Modus",
    modeFixed: "Faste vekter",
    modeFixedHint: "Én eksakt vekt per instrument; ethvert avvik er et brudd.",
    modeMinMax: "Min/maks-vekter",
    modeMinMaxHint:
      "Et minimum, en standard og et maksimum per instrument; utenfor båndet er et brudd.",
    instruments: "Instrumenter",
    save: "Lagre",
    cancel: "Avbryt",
    nameRequired: "Navn er obligatorisk",
    needLines: "Legg til minst ett instrument",
    fixedTotal: "Vektene må summere til 100 %",
    defaultTotal: "Standardvektene må summere til 100 %",
    rangeOrder: "Hvert instrument trenger minimum ≤ standard ≤ maksimum",
    rangeUnreachable: "Båndene må tillate en allokering som summerer til 100 %",
    pctRange: "Alle tall må være mellom 0 og 100",
    uncovered: "Fjern instrumentene som ikke er tilgjengelige på alle valgte plattformer",
    failedToSave: "Kunne ikke lagre malen",
  },
} as const;
